// src/ResultsPage.js
import React from 'react';
import ReactDOM from 'react-dom';
import '../css/ResultsPage.css';

const ResultsPage = ({ results, onClose, onShowExplanation }) => {
  const handleShowExplanation = () => {
    onClose(); // Close the results page
    onShowExplanation(); // Show the explanation
  };

  return ReactDOM.createPortal(
    <div className="results-overlay">
      <div className="results-page">
        <div className="results-header">
          <h2>Solar Panel Calculator Results</h2>
          <div className="results-buttons">
            <button onClick={handleShowExplanation} className="explanation-button">
              How We Calculate
            </button>
            <button onClick={onClose} className="close-button">
              &times;
            </button>
          </div>
        </div>
        <div className="results-container">
          <div className="results-column">
            <table className="results-table">
              <tbody>
                {/* System Requirements Section */}
                <tr className="subheading">
                  <td colSpan="2">System Requirements</td>
                </tr>
                <tr>
                  <td>Average Daily Electricity Usage:</td>
                  <td className="results-value">{results.dailyUsage} kWh/day</td>
                </tr>
                <tr>
                  <td>System Size Required:</td>
                  <td className="results-value">{results.systemSize} kW</td>
                </tr>
                <tr>
                  <td>Number of Panels Required:</td>
                  <td className="results-value">{results.numberOfPanels} panels</td>
                </tr>
              </tbody>
            </table>
            
                <table className="results-table">
                  <tbody>
                    {/* Cost Analysis Section */}
                    <tr className="subheading">
                      <td colSpan="2">Cost Analysis</td>
                    </tr>
                    <tr>
                      <td>Total Panel Cost:</td>
                      <td className="results-value">£{results.totalPanelCost}</td>
                    </tr>
                    <tr>
                      <td>Total Installation Cost:</td>
                      <td className="results-value">£{results.totalInstallationCost}</td>
                    </tr>
                    <tr>
                      <td>Total Cost:</td>
                      <td className="results-value">£{results.totalCost}</td>
                    </tr>
                    <tr>
                      <td>Net Cost after Incentives:</td>
                      <td className="results-value">£{results.netCost}</td>
                    </tr>
                  </tbody>
                </table>
          </div>

          <div className="results-column">
            <table className="results-table">
              <tbody>
                {/* System Performance Section */}
                <tr className="subheading">
                  <td colSpan="2">System Performance</td>
                </tr>
                <tr>
                  <td>Adjusted System Efficiency:</td>
                  <td className="results-value">{results.adjustedEfficiency}%</td>
                </tr>
                <tr>
                  <td>Estimated Power Received:</td>
                  <td className="results-value">{results.powerReceived} kWh/day</td>
                </tr>
              </tbody>
            </table>

            <table className="results-table">
              <tbody>
                {/* Financial Impact Section */}
                <tr className="subheading">
                  <td colSpan="2">Financial Impact</td>
                </tr>
                <tr>
                  <td>Current Annual Electricity Cost:</td>
                  <td className="results-value">£{results.currentAnnualCost}</td>
                </tr>
                <tr>
                  <td>Annual Solar Production:</td>
                  <td className="results-value">{results.annualSolarProduction} kWh/year</td>
                </tr>
                <tr>
                  <td>Annual Savings (Self-consumption):</td>
                  <td className="results-value">£{results.annualSavings}</td>
                </tr>
                <tr>
                  <td>Export Profit:</td>
                  <td className="results-value">£{results.exportProfit}</td>
                </tr>
                <tr>
                  <td>Total Annual Benefit:</td>
                  <td className="results-value">£{(parseFloat(results.annualSavings) + parseFloat(results.exportProfit)).toFixed(2)}</td>
                </tr>
                <tr>
                  <td>Payback Time:</td>
                  <td className="results-value">{results.paybackTime} years</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <p className="disclaimer">
          Disclaimer: The results provided are estimates only and may vary based on individual circumstances. For precise information and personalized advice, please consult a certified solar energy provider at sunstore.co.uk.
        </p>
        
        {/* New section for the "Explore Solar Products" button */}
        <div className="explore-solar-products" style={{ width: '100%' }}>
          <a 
            href="https://www.sunstore.co.uk/?aff=SolarWealthPlanner" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              textDecoration: 'none',
              display: 'block',
              width: '100%'
            }}
          >
            <button 
              style={{
                backgroundColor: '#FFA500',
                color: '#000000',
                padding: '15px 30px',
                fontSize: '1.2rem',
                fontWeight: 'bold',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                display: 'block',
                width: '100%',
                marginTop: '20px',
                marginBottom: '10px',
                transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-3px)';
                e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}
            >
              Consult sunstore.co.uk
            </button>
          </a>
          <i style={{ display: 'block', textAlign: 'center', marginBottom: '20px' }}>
            *sponsored link
          </i>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ResultsPage;
